import { type FC, useCallback, useMemo } from 'react';
import { getDialectByCode } from '@reacture-io/iso-locale/languages';
import { isValidLanguage } from '@repo/shared';

import Combobox, {
  type CmdkFilterHandler,
  type ComboboxProps,
} from '@/components/ui/combobox';

type LanguageComboboxProps = Omit<ComboboxProps<false>, 'options'>;

const LanguageCombobox: FC<LanguageComboboxProps> = ({ ...props }) => {
  const options = useMemo(
    () =>
      ['en-US', 'en-GB', 'nl-BE', 'nl-NL']
        .filter(isValidLanguage)
        .map((code) => {
          const dialect = getDialectByCode(code);
          return {
            label: dialect.dialect,
            value: code,
            keywords: [
              dialect.bcp47,
              dialect.dialect,
              dialect.native,
              dialect.iso639_1,
              dialect.iso639_3,
            ].filter(Boolean) as Array<string>,
          };
        }),
    []
  );

  const handleFilter: CmdkFilterHandler = useCallback(
    (_, search, keywords) =>
      keywords?.some((keyword) =>
        keyword.toLowerCase().includes(search.toLowerCase())
      )
        ? 1
        : 0,
    []
  );

  return (
    <Combobox
      {...props}
      options={options}
      onFilter={handleFilter}
    />
  );
};

export default LanguageCombobox;
